import { render, staticRenderFns } from "./zorderdetail.vue?vue&type=template&id=65716694&scoped=true"
import script from "./zorderdetail.vue?vue&type=script&lang=js"
export * from "./zorderdetail.vue?vue&type=script&lang=js"
import style0 from "./zorderdetail.vue?vue&type=style&index=0&id=65716694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65716694",
  null
  
)

export default component.exports